<div class="registration-terms-and-condition">
  <h5>{{ 'fgbcl.registration.terms.and.condition.title' | translate }}</h5>
  <div class="content" #content (scroll)="onScroll($event)">
    <fgbcl-terms-and-conditions [type]="termsAndConditionsType" [defaultTerms]="loading"></fgbcl-terms-and-conditions>
    <ng-container *ngIf="showScrollButton">
      <div class="scroll-bottom-wrapper" *ngIf="!isButtonHidden">
        <button id="terms-scroll-button" (click)="scrollToBottom()">
          {{ 'registration.terms.and.conditions.scroll.bottom.button' | translate: { fgbdefault: 'Scroll to bottom' } }}
        </button>
      </div>
      <div #bottom></div>
    </ng-container>
  </div>
</div>

<div class="wrap-accept-box">
  <div class="accept-box">
    <div class="form-check">
      <input
        class="form-check-input"
        id="accepted"
        type="checkbox"
        [(ngModel)]="accepted"
        (click)="handleCheckboxClick()"
        required
      />
      <label for="accepted" class="accept-box-label">{{ 'registration.accept.terms.and.conditions' | translate }}</label>
    </div>
    <fgbcl-errors></fgbcl-errors>
  </div>
</div>

<div class="registration-navigataion-button-container">
  <fgbcl-registration-navigation (nextButtonClicked)="submitStep()" [stepType]="stepType"></fgbcl-registration-navigation>
</div>
